import { useState, useEffect } from 'react';
import { useComponentEntries } from './hook.component-entries.js';
import { useComponentEntrySelector } from './state.js';

/**
 * when changing timespans an async operation may begin. In order to know which
 * timespan tables currently are rendered with then this hook can be used as it
 * retains the timespan which the current data is applied with.
 */
function useAppliedTimespan() {
  const desiredTimespan = useComponentEntrySelector(state => state.filters.timespan);
  const entries = useComponentEntries(desiredTimespan);
  const [prevTimespan, setPrevTimespan] = useState(desiredTimespan);
  useEffect(() => {
    if (desiredTimespan !== prevTimespan) {
      return;
    }
    setPrevTimespan(desiredTimespan);
  }, [entries.isPlaceholderData, prevTimespan, desiredTimespan]);
  return entries.isPlaceholderData ? prevTimespan : desiredTimespan;
}

export { useAppliedTimespan };
//# sourceMappingURL=hook.applied-timespan.js.map
